import React from 'react';
import cn from 'classnames';
import { Badge, Typography } from 'seagull';
import { CopyToClipboard } from "../../components/CopyToClipboard/CopyToClipboard";
import styles from "./CopyLinkForProposalModal.module.scss";
export function getRecipientBadgeInfo(_ref) {
  let {
    isSignatureRequired,
    hasSigned,
    isPrimary
  } = _ref;
  if (!isSignatureRequired) return null;
  if (hasSigned) return {
    text: 'Signed',
    skin: 'success',
    badgeSkin: 'success'
  };
  // even if primary contact - if signed return signed
  else if (isPrimary) return {
    text: 'Primary contact',
    skin: 'disabled'
  };
  // if primary contact and not signed return primary contact
  else return {
    text: 'Required to sign',
    skin: 'disabled'
  };
}
function RecipientBadge(props) {
  const badgeInfo = getRecipientBadgeInfo(props);
  return badgeInfo && /*#__PURE__*/React.createElement(Badge, {
    rounded: true,
    outlined: true,
    "data-testid": props.testid,
    skin: badgeInfo.badgeSkin
  }, /*#__PURE__*/React.createElement(Typography, {
    skin: badgeInfo.skin,
    variant: "paragraph2"
  }, badgeInfo.text));
}
export function CopyLinkForProposalModal(props) {
  const {
    className,
    onClick,
    onError,
    onCopy,
    recipients,
    info
  } = props;
  const dataTestId = props['data-testid'] || 'copy-to-clipboard';
  const Recipient = _ref2 => {
    let {
      recipient,
      isPrimary = false
    } = _ref2;
    const {
      email,
      isSignatureRequired,
      hasSigned,
      notificationURL
    } = recipient;
    return /*#__PURE__*/React.createElement("div", {
      className: styles.linkRow
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.reviewerDetails
    }, /*#__PURE__*/React.createElement(Typography, {
      ellipsis: true,
      variant: 'paragraph1',
      weight: 'normal',
      "data-testid": 'recipient-name'
    }, recipient.fullName()), /*#__PURE__*/React.createElement(Typography, {
      ellipsis: true,
      variant: 'paragraph2',
      weight: 'light',
      "data-testid": 'recipient-email'
    }, email)), /*#__PURE__*/React.createElement("div", {
      className: styles.badge
    }, /*#__PURE__*/React.createElement(RecipientBadge, {
      isSignatureRequired: isSignatureRequired,
      hasSigned: hasSigned,
      isPrimary: isPrimary,
      testid: "recipient-badge-".concat(email)
    })), /*#__PURE__*/React.createElement(CopyToClipboard, {
      value: notificationURL,
      buttonLabel: 'Copy',
      onClick: onClick,
      onError: onError,
      onCopy: onCopy,
      buttonClassname: styles.button,
      textfieldClassname: styles.link,
      className: styles.linkWrapper
    }));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: cn(styles.multipleRecipientsRoot, className),
    "data-testid": dataTestId
  }, /*#__PURE__*/React.createElement(Typography, {
    className: styles.title
  }, "Links are unique per recipient. Make sure that each link is sent to the intended recipient."), info, /*#__PURE__*/React.createElement("div", {
    className: styles.linksContainer
  }, /*#__PURE__*/React.createElement(Recipient, {
    key: recipients.primary.email,
    recipient: recipients.primary,
    isPrimary: true
  }), recipients.additionalRecipients.length > 0 && /*#__PURE__*/React.createElement(Typography, {
    className: styles.additionalRecipientsTitle
  }, "Additional recipients:"), recipients.additionalRecipients.map(recipient => /*#__PURE__*/React.createElement(Recipient, {
    key: recipient.email,
    recipient: recipient
  }))));
}